<template>
	<v-card class="card-rounded elevation-1 mb-3 justify-bottom text-left" style="width: 100%">
		<v-card-title class="pa-0 pb-0 ma-0">
			<v-spacer></v-spacer>
			<v-btn icon @click="hide()"><v-icon>close</v-icon></v-btn>
		</v-card-title>
		<v-list-item three-line>
			<v-icon v-if="avatar" size="80" color="gray">{{ avatar }}</v-icon>
			<v-list-item-content>
				<v-list-item-title class="mb-1"
					><h2>{{ title }}</h2></v-list-item-title
				>
				<v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>

		<v-card-actions>
			<v-btn v-for="action in actions" :key="action" :v-if="actions" @click="action.onclick">
				{{ action.text }}
			</v-btn>
			<v-spacer></v-spacer>

			<v-btn
				text
				router
				:to="'/'"
				style="
					color: var(--v-primary-base);
					font-family: Montserrat;
					font-style: normal;
					font-weight: normal;
					font-size: 14px;
					line-height: 17px;
					text-align: right;
					text-decoration-line: underline;
				"
			>
				Go to dashboard
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { bus } from '@/main';

export default {
	components: {},
	data: () => ({
		title: 'TITLE',
		subtitle: 'subtitle',
		avatar: true,
		actions: false,
	}),

	created() {
		bus.$on('push:notification@update', notification => {
			this.title = notification.title;
			this.subtitle = notification.subtitle;
			this.avatar = 'avatar' in notification ? notification.avatar : true;
			this.actions = 'actions' in notification ? notification.actions : false;
		});
	},

	methods: {
		hide() {
			bus.$emit('push:notification@hide');
		},
	},
};
</script>
